export default __webpack_public_path__ + "static/media/white_mailchimp.274880df.png";